import { ajax } from '../index'

/**
 * Add-on related api
 */
export default {
  // Get add-on list
  getAddOnList(params: any) {
    return ajax.get('api', `/api/v1/addon/list`, params)
  },

  // Get add-on red zone list
  getAddOnRedZone(params: any) {
    return ajax.get('api', `/api/v1/addon/red-zone`, params)
  },

  // Get add-on category map
  getAddOnCateMap(params: any) {
    return ajax.get('api', `/api/v1/addon/cate-map`, params)
  },

  // Get selected add-ons
  getSelectedAddOns() {
    return ajax.get('api', `/api/v1/addon/selected`, {})
  }
}
